import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=6d4e3c6c&"
import script from "./OrgInfo.vue?vue&type=script&lang=js&"
export * from "./OrgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports